const getters = {
  userInfo: state => state.app.userInfo,
  config: state => state.app.config
}
export default getters